export const COLUMNS = ["shareholder", "sharesOwnedAtUpvote", "upvotedAt"];
